import React from 'react';
import { Document, Page, View, Text, StyleSheet } from '@react-pdf/renderer';
import {
    ContactSection, BadgeListSection, SocialSection,
    AboutSection, ExperienceSection, EducationSection, ReferencesSection,
} from './PdfSections';

const styles = StyleSheet.create({
    page: { flexDirection: 'row', padding: 30, fontSize: 10, fontFamily: 'Helvetica' },
    left: { width: '35%', paddingRight: 15 },
    right: { width: '65%', paddingLeft: 15 },
    name: { fontSize: 18, fontWeight: 'bold', marginBottom: 4 },
    title: { fontSize: 11, color: '#555555', marginBottom: 12 },
});

function Template1Pdf(props) {
    const {
        name, about, email, address, phone, title,
        technicalSkills, languages, softSkills,
        linkedinURL, twitterURL, githubURL, websiteURL,
        educationData, jobData, showSocial, referenceData,
    } = props;

    return (
        <Document>
            <Page size="A4" style={styles.page} wrap>
                <View style={styles.left}>
                    <Text style={styles.name}>{name}</Text>
                    <Text style={styles.title}>{title}</Text>
                    <ContactSection email={email} phone={phone} address={address} />
                    <BadgeListSection title="Professional Skills" items={technicalSkills} />
                    <BadgeListSection title="Soft Skills" items={softSkills} />
                    <BadgeListSection title="Languages Known" items={languages} />
                    <SocialSection linkedinURL={linkedinURL} twitterURL={twitterURL} githubURL={githubURL} websiteURL={websiteURL} showSocial={showSocial} />
                </View>
                <View style={styles.right}>
                    <AboutSection about={about} />
                    <ExperienceSection jobData={jobData} />
                    <EducationSection educationData={educationData} />
                    <ReferencesSection referenceData={referenceData} />
                </View>
            </Page>
        </Document>
    );
}

export default Template1Pdf;